import { useNavigate } from 'react-router-dom';
import { useTranslations } from '@altermaind/core/i18n';
import { Card, Typography } from '@altermaind/web/ui';
import { RenderLocalesWithComponents } from '@/_shared/components/RenderLocalesWithComponents';
import { Routes } from '@/_shared/constants/routes';

export const EmptyStateNoDepartments = () => {
  const t = useTranslations('departments.emptyStateNoDepartments');
  const navigate = useNavigate();

  const goToPeople = () => {
    navigate(Routes.People);
  };

  return (
    <Card data-testid='empty-state-no-departments' textAlign='center' bg='transparent'>
      <Typography variant='h1' mb='s'>
        {t('title')}
      </Typography>
      <Typography variant='p2/light'>
        <RenderLocalesWithComponents
          text={t('description', {
            downloadFile: '!{CTA}!',
          })}
          placeholders={{
            '!{CTA}!': (
              <Typography
                as='span'
                color='primary'
                data-testid='go-to-people-link'
                fontWeight='500'
                style={{ textDecoration: 'underline', cursor: 'pointer' }}
                onClick={goToPeople}
              >
                {t('ctaLabel')}
              </Typography>
            ),
          }}
        />
      </Typography>
    </Card>
  );
};
